import request from '#/utils/request';
import { keysToSnake } from '#/api/adapters/wireCase';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

import { mapCustomerRecordSnCodes } from './snCodeWire';

/**
 * 啟用客戶。
 * `POST /crm/customer/{id}/activate`；body `{ updatedAt }`。
 *
 * @param {string} id
 * @param {{ updatedAt?: string }} [payload]
 */
export async function activateCustomer(id, payload = {}) {
  const { data: raw } = await request.post(
    `/crm/customer/${id}/activate`,
    keysToSnake(payload),
  );
  const parsed = parseVer4DetailResponse(raw);
  return { ...parsed, data: mapCustomerRecordSnCodes(parsed.data) };
}
